module.exports = __webpack_public_path__ + "img/oldSenora.afec295d.png";